import {useEffect, useState} from 'react';
import {identityApiRef, useApi} from '@backstage/core-plugin-api';

export type LoggedInUser = {
  userEntityRef: string;
  email: string;
};

/**
 * The identity of the currently logged in user. Used to record who registered
 * a component (see the `pariveda.io/registered-by` annotation), independent of
 * spec.owner which stays `parivedasolutions` per existing taxonomy convention.
 */
export const useLoggedInUser = (): LoggedInUser | undefined => {
  const identityApi = useApi(identityApiRef);
  const [user, setUser] = useState<LoggedInUser>();

  useEffect(() => {
    let cancelled = false;
    Promise.all([identityApi.getBackstageIdentity(), identityApi.getProfileInfo()]).then(
      ([identity, profile]) => {
        if (!cancelled) {
          setUser({
            userEntityRef: identity.userEntityRef,
            email: profile.email ?? '',
          });
        }
      },
    );
    return () => {
      cancelled = true;
    };
  }, [identityApi]);

  return user;
};
